import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import AboutUs from "./views/AboutUs";
import AssetTrackingSystem from "./views/AssetTrackingSystem";
import DigitalLogging from "./views/DigitalLogging";
import ITSolutionsHardware from "./views/ITSolutionsHardware";
import SecuritySolutions from "./views/SecuritySolutions";
import WhatWeOffer from "./views/WhatWeOffer";
import Page404 from "./views/404";

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    {
      path: "/about-us",
      name: "about-us",
      components: {
        header: AppHeader,
        default: AboutUs,
        footer: AppFooter
      }
    },
    {
      path: "/what-we-offer",
      name: "what-we-offer",
      components: {
        header: AppHeader,
        default: WhatWeOffer,
        footer: AppFooter
      }
    },
    {
      path: "/asset-tracking-system",
      name: "asset-tracking-system",
      components: {
        header: AppHeader,
        default: AssetTrackingSystem,
        footer: AppFooter
      }
    },
    {
      path: "/digital-logging",
      name: "digital-logging",
      components: {
        header: AppHeader,
        default: DigitalLogging,
        footer: AppFooter
      }
    },
    {
      path: "/it-solutions-hardware",
      name: "it-solutions-hardware",
      components: {
        header: AppHeader,
        default: ITSolutionsHardware,
        footer: AppFooter
      }
    },
    {
      path: "/security-solutions",
      name: "security-solutions",
      components: {
        header: AppHeader,
        default: SecuritySolutions,
        footer: AppFooter
      }
    },
    {
      path: '/404',
      name: '404',
      meta: { isPublic: true },
      component: Page404,
      alias: '*'
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
